import styled from "styled-components";
import Select from '@material-ui/core/Select';

export const Item = styled.div`
    margin-left: 10px;
    color: #4f4f4f;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px;
    width: 100%;
    font-size: 12px !important;
    cursor: pointer;
    `
export const SubItem = styled.div`
    margin-left: 15px;
    color: #4f4f4f;
    `
export const wrapperTop = styled.div`
    width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

    `
export const SelectAll = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #4f4f4f;
        margin-top: 5px;
        padding: 7px;
        border-bottom: 1px #e0e0e0 solid;
        div{
            display: flex;
            align-items: center;
        }
        :hover {
        background-color: transparent;
  }
    `
export const ClearAll = styled.button`
background-color: transparent;
border: 0;
`
